import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { updateStatutMission } from '../../api/commande'
import toast from 'react-hot-toast'
import { useHistory } from 'react-router'
import Modal from 'react-modal'
import moment from 'moment'
import { useTranslation } from 'react-i18next'


function MissionHorizontal({
    commande,
    hideStatus = false,
    hideSignalement = false,
    onClickDetails = () => { },
    setUpdateStatus
}) {
    const token = useSelector((state) => state.auth.token);
    const [loading, setLoading] = useState(false)
    const [modalIsOpenStatusEnCours, setModalIsOpenStatusEnCours] = useState(false)
    const history = useHistory()

    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
    const [isTablette, setIsTablette] = useState(() => window.innerWidth < 1024 && window.innerWidth >= 768);

    useEffect(() => {
        const checkScreen = () => {
            const width = window.innerWidth;

            setIsMobile(width < 768);
            setIsTablette(width >= 768 && width < 1024);
        };
        checkScreen();
        window.addEventListener('resize', checkScreen);

        return () => window.removeEventListener('resize', checkScreen);
    }, []);
    const renderVehicleOption = (option) => {
        switch (option) {
            case "Frigorifique":
                return t("refrigerated");
            case "Bachée":
                return t("tarped");
            case "Hayon":
                return t("liftgate");
            default:
                return option;
        }
    };
    const renderHeavyVehicleType = (type) => {
        switch (type) {
            case "Tracteur+semi":
                return t("tractor_semi");
            case "Semi":
                return t("semi");
            case "Tracteur":
                return t("tractor");
            default:
                return type;
        }
    };
    const renderLightVehicleType = (type) => {
        switch (type) {
            case "Break":
                return t("break") ;
            case "Fourgon":
                return t("fourgon") ;
            case "Camion":
                return t("camion");
            default:
                return type;
        }
    };
    const { t } = useTranslation()
    return (
        <div
            style={{
                width: '100%',
                background: '#E4EAF0',
                padding: '1rem',
                borderRadius: 10,
                marginBottom: 10,

            }}>
            <div style={{
                marginBottom: '1rem',
                display: 'flex',
                flexDirection: isMobile ? "column" : 'row',
                gap: '10px',
                justifyContent: 'space-between'
            }}>
                <span
                    style={{
                        fontWeight: 'bold',
                        color: '#51C7F2',
                        fontSize: 13,
                    }}
                >
                    {t("mise_à_disposition")} {commande ? 'N°' + commande.__id : ''} /{' '}
                    <span style={{ color: '#1C63C5' }}>
                        {commande.temporisation === 'immediat'
                            ? t("immédiate")
                            : t("planifiée")}
                    </span>
                </span>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    <button
                        onClick={onClickDetails}
                        style={{
                            padding: '0.5rem 1.5rem',
                            background: '#51C7F2',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'white',
                            borderRadius: 7,
                            marginTop: 5,
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            width: '140px',

                        }}
                    >
                        {t("view_details")}
                    </button>

                </div>
            </div>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ width: '100%' }}>
                        {commande.missions.map((mission, index) => (
                            <div key={index}>
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        color: '#51C7F2',
                                        fontSize: 13,
                                    }}
                                >
                                    Mission N° {index + 1} {' '}
                                </span>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: isMobile || isTablette ? 'column' : 'row',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}>
                                    <div
                                        style={{
                                            width: '80%',
                                            background: '#E4EAF0',
                                            display: 'grid',
                                            gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : isTablette ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                                            gap: '10px',
                                            padding: '1rem',
                                            borderRadius: 10,
                                            alignItems: 'flex-start',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: '#838EAB',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                fontSize: 13,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    marginRight: 13,
                                                    marginTop: "0.5rem",
                                                    marginBottom: '0.5rem',
                                                    color: '#838EAB',
                                                    width: '15rem',
                                                }}
                                            >
                                                {t("start_address")} : {' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {mission?.adresse_debut?.label}
                                                </span>
                                            </span>
                                            <span
                                                style={{
                                                    marginRight: 13,
                                                    marginBottom: '0.5rem',
                                                    color: '#838EAB',
                                                    width: '15rem',
                                                }}
                                            >
                                                {t("end_address")} : {' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {mission?.adresse_fin?.label}
                                                </span>
                                            </span>
                                            <span
                                                style={{
                                                    marginRight: 13,
                                                    marginBottom: '0.5rem',
                                                    color: '#838EAB',
                                                    width: '15rem',
                                                }}
                                            >
                                                {t("start_date")} : {' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {mission?.date_debut} {mission?.heure_debut} {' '}
                                                </span>
                                            </span>
                                            <span
                                                style={{
                                                    marginRight: 13,
                                                    marginBottom: '0.5rem',
                                                    color: '#838EAB',
                                                    width: '15rem',
                                                }}
                                            >
                                                {t("end_date")} :{' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {mission?.date_fin} {mission?.heure_fin} {' '}
                                                </span>
                                            </span>
                                        </div>
                                        <div

                                            style={{
                                                //padding: '0.5rem 2rem',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                color: '#838EAB',
                                                fontSize: 13,
                                                borderRadius: 5,
                                                marginBottom: 3,
                                            }}
                                        >
                                            {!hideStatus &&
                                                <>
                                                    <span
                                                        onClick={() => {
                                                            if (mission.statut === "en-cours") {
                                                                toast.error(t("mission_started"), {
                                                                    style: {
                                                                        fontFamily: 'Montserrat',
                                                                    },
                                                                })
                                                            } else {
                                                                setModalIsOpenStatusEnCours(true)
                                                            }
                                                        }}
                                                        style={{
                                                            padding: '0.3rem 0.7rem',
                                                            background: mission?.statut === 'en-cours' ? '#C752B6' : '#838EAB',
                                                            color: mission?.statut === 'en-cours' ? 'white' : '#9EA8BF',
                                                            borderRadius: 50,
                                                            fontWeight: 'bold',
                                                            marginBottom: 5,
                                                            fontSize: 10,
                                                            cursor: 'pointer',
                                                            width: '5.5rem',
                                                            textAlign : 'center'
                                                        }}
                                                    >
                                                        {t("in_progress")}
                                                    </span>

                                                </>}

                                            {mission?.date_debut_reel &&
                                                <span
                                                    style={{
                                                        marginRight: 13,
                                                        marginBottom: '0.5rem',
                                                        color: '#838EAB',
                                                        width: '15rem',
                                                    }}
                                                >
                                                    {t("actual_start_date")} : {' '}
                                                    <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                        {moment(mission?.date_debut_reel).format('DD/MM/YYYY HH:mm')}{' '}
                                                    </span>
                                                </span>
                                            }
                                            {mission?.date_fin_reel &&
                                                <span
                                                    style={{
                                                        marginRight: 13,
                                                        marginBottom: '0.5rem',
                                                        color: '#838EAB',
                                                        width: '13rem',
                                                    }}
                                                >
                                                    {t("actual_end_date")} :{' '}
                                                    <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                        {moment(mission?.date_fin_reel).format('DD/MM/YYYY HH:mm')}{' '}
                                                    </span>
                                                </span>
                                            }

                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                marginLeft: '0.5rem',
                                                marginRight: '0.5rem',
                                                fontSize: 13,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: '#838EAB',
                                                    marginBottom: '0.5rem',
                                                }}
                                            >
                                                {t("km_number")} :{' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {mission.kilometrage}
                                                </span>
                                            </span>
                                            <span style={{ color: '#838EAB' }}>
                                                {t("nombre_rippeur")} :{' '}
                                                <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
                                                    {(mission.nombre_rippeur === null || mission.nombre_rippeur === undefined) ? '0' : mission.nombre_rippeur}
                                                </span>
                                            </span>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    marginTop: '0.5rem',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: '#838EAB',
                                                        marginBottom: '.5rem',
                                                    }}
                                                >
                                                    {mission.type_transport === "Poids lourds" ? t("vehicle_type1") : t("vehicle_type2")}{' : '}
                                                    {mission.type_transport === "Poids lourds" ? renderHeavyVehicleType(mission.vehicule_poids_lourds) : renderLightVehicleType(mission.type_transport_details)}
                                                </span>
                                                <span style={{ color: '#838EAB', marginBottom: '.5rem' }}>
                                                    {mission?.options_vehicule_leger
                                                        ?.map(option => renderVehicleOption(option))
                                                        .join(", ")}

                                                </span>
                                                <span style={{ color: '#838EAB', marginBottom: '.5rem' }}>
                                                    {mission?.options_poids_lourds
                                                        ?.map(option => renderVehicleOption(option))
                                                        .join(", ")
                                                    }
                                                </span>
                                            </div>
                                        </div>



                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            justifyContent: 'space-between',
                                            //width:'20%',
                                        }}>
                                        <>
                                            {(mission?.statut === 'en-cours' || mission?.statut === 'terminer') &&
                                                <button
                                                    onClick={() => {
                                                        history.push(`/chauffeur/adresses/${mission._id}`)
                                                    }}
                                                    style={{
                                                        padding: '0.5rem 1.5rem',
                                                        background: '#51C7F2',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        color: 'white',
                                                        borderRadius: 7,
                                                        marginTop: 5,
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 'bold',
                                                        width: '160px',

                                                    }}
                                                >
                                                    {t("add_address")}
                                                </button>
                                            }
                                            {!hideSignalement &&
                                                <button
                                                    onClick={() => {
                                                        history.push(`/chauffeur/mission/${mission._id}/single`)
                                                    }}
                                                    style={{
                                                        padding: '0.5rem 1.5rem',
                                                        background: '#51C7F2',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        color: 'white',
                                                        borderRadius: 7,
                                                        marginTop: 5,
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 'bold',
                                                        width: '160px',

                                                    }}
                                                >
                                                    {t("reports")}
                                                </button>
                                            }
                                        </>
                                    </div>


                                </div>
                                <Modal
                                    isOpen={modalIsOpenStatusEnCours}
                                    style={{
                                        overlay: {
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgba(0, 0, 0, 0.45)',
                                        },
                                        content: {
                                            top: '50%',
                                            left: '50%',
                                            right: 'auto',
                                            bottom: 'auto',
                                            marginRight: '-50%',
                                            transform: 'translate(-50%, -50%)',
                                            borderRadius: 19,
                                            padding: '2rem',
                                            maxWidth: '400px',
                                            width: '90%'
                                        },
                                    }}
                                    contentLabel='Example Modal'
                                >
                                    <div
                                        style={{
                                            //width: '20rem',
                                            fontFamily: 'Montserrat',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 15,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: 'bold',
                                                fontFamily: 'Montserrat',
                                                fontSize: 20,
                                                color: '#51C7F2',
                                            }}
                                        > {t("start_mission")}</div>
                                        <div
                                            style={{
                                                marginTop: 4,
                                                width: '100%',
                                            }}
                                        >

                                            <p>{t("start_mission_confirmation")} </p>

                                        </div>
                                        <div
                                            style={{
                                                width: '100%',
                                                fontFamily: 'Montserrat',
                                                paddingLeft: '1rem',
                                                paddingRight: '1rem',
                                                marginBottom: '5px',
                                                marginTop: '1rem',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}>
                                            <button

                                                onClick={async () => {
                                                    setLoading(true)
                                                    try {
                                                        const response = await updateStatutMission(
                                                            mission._id,
                                                            commande._id,
                                                            token
                                                        )
                                                        toast.success(response.message, {
                                                            style: {
                                                                fontFamily: 'Montserrat',
                                                            },
                                                        })
                                                        setUpdateStatus(true)
                                                    } catch (error) {
                                                        toast.error(error.response?.data.error || t("error_updating_mission_status"), {
                                                            style: {
                                                                fontFamily: 'Montserrat',
                                                            },
                                                        })

                                                    } finally {
                                                        setModalIsOpenStatusEnCours(false)
                                                        setLoading(false)
                                                    }


                                                }}

                                                disabled={loading}
                                                style={{
                                                    width: "150px",
                                                    height: "50px",
                                                    background: '#50F5A9',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    color: 'white',
                                                    borderRadius: 7,
                                                    marginTop: 5,
                                                    fontFamily: 'Montserrat',
                                                    marginRight: 10,
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}

                                            >
                                                {loading ? (
                                                    <div className='loader'></div>
                                                ) : (
                                                    t("confirm")
                                                )}
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setModalIsOpenStatusEnCours(false)

                                                }}
                                                style={{
                                                    width: "150px",
                                                    height: "50px",
                                                    background: 'red',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    color: 'white',
                                                    borderRadius: 7,
                                                    marginTop: 5,
                                                    fontFamily: 'Montserrat',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                
                                                {t("cancel")}
                                            </button>
                                        </div>

                                    </div>
                                </Modal>

                            </div>
                        ))}
                    </div>

                </div>

            </div>
        </div>

    )
}

export default React.memo(MissionHorizontal)
